import type { YesNo } from "../../hooks/useLeadFormState";

export const RadioYesNo = ({
  name,
  value,
  onChange,
  label,
}: {
  name: string;
  value: YesNo;
  onChange: (v: YesNo) => void;
  label: string;
}) => (
  <div className="tdb-field" style={{ alignItems: "flex-start" }}>
    <div style={{ width: "100%" }}>
      <div style={{ marginBottom: 10, fontWeight: 600, fontSize: 12 }}>
        {label}
      </div>
      <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
        <label
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            fontSize: 12,
          }}
        >
          <input
            type="radio"
            name={name}
            style={{ accentColor: "black", margin: 0 }}
            checked={value === "yes"}
            onChange={() => onChange("yes")}
          />
          Oui
        </label>
        <label
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            fontSize: 12,
          }}
        >
          <input
            type="radio"
            name={name}
            style={{ accentColor: "black", margin: 0 }}
            checked={value === "no"}
            onChange={() => onChange("no")}
          />
          Non
        </label>
      </div>
    </div>
  </div>
);
